import { application } from './application'

import { registerControllers } from 'stimulus-vite-helpers'

const controllers = import.meta.glob(
  [
    '../*_controller.js', // Shared controllers
    './**/*_controller.js' // Directory controllers
  ],
  { eager: true }
)
registerControllers(application, controllers)

